import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { CommonLayout } from '../commonComponents';
import ExploreMutualFund from './exploreMutualFund';
import InvestorProfile from '.';
import IndividualFundDetails from './fundDetails';
import MutualFund from './mutualFund';
import OrderDetails from './mutualFund/orders/OrderDetails';
import ViewProfile from './viewProfile';
import DownloadUploadXSIP from './mutualFund/mandates/DownloadUploadXSIP';
import CategoryWiseActionItems from './mutualFund/CategoryWiseActionItems';
import DirectEquity from './directEquity';
import PMS from './pms';
import Bonds from './bonds';
import Alternates from './alternates';
import ReasonForCancellation from './mutualFund/systematicPlans/ReasonForCancellation';
import EditRiskProfile from './EditRiskProfile';
import Transaction from './transcation';
import Swp from './mutualFund/swp/index';
import SwitchAndStp from './mutualFund/switchAndStp/index';
import Redeem from './mutualFund/redeem';
import PauseSIP from './mutualFund/systematicPlans/PauseSIP';
import EcasDownloads from './eCasDownloads';
import SelectedCategorySchemes from './exploreMutualFund/SelectedCategorySchemes';
import SIPCalculator from './exploreMutualFund/SIPCalculator';
import GoalCalculator from './exploreMutualFund/GoalCalculator';
import Notifications from './Notifications';

const routerList = [
    {
        name: 'Investor Profile',
        path: "",
        component: InvestorProfile,
    },
    {
        name: "Notifications",
        path: "notifications",
        component: Notifications
    },
    {
        name: "Edit Risk Profile",
        path: "edit-risk-profile",
        component: EditRiskProfile,
    },
    {
        name: 'View Profile',
        path: 'view-profile',
        component: ViewProfile,
    },
    {
        name: 'Detailed Portfolio Holdings',
        path: 'mutual-fund',
        component: MutualFund,
    },
    {
        name: 'Direct Equity',
        path: 'direct-equity',
        component: DirectEquity,
    },
    {
        name: 'PMS',
        path: 'pms',
        component: PMS,
    },
    {
        name: 'Debt',
        path: 'debt',
        component: Bonds,
    },
    {
        name: 'Alternates',
        path: 'alternates',
        component: Alternates,
    },
    {
        name: 'Category Wise Breakup',
        path: 'mutual-fund/category-wise-breakup',
        component: CategoryWiseActionItems
    },
    {
        name: 'Order Details',
        path: 'mutual-fund/:orderId/order-details',
        component: OrderDetails,
    },
    {
        name: 'Pause SIP',
        path: 'mutual-fund/pause-sip',
        component: PauseSIP
    },
    {
        name: 'Reason for cancellation',
        path: 'mutual-fund/:typeid/reason-for-cancellation',
        component: ReasonForCancellation,
    },
    {
        name: 'Explore Mutual Funds',
        path: 'mutual-fund/explore',
        component: ExploreMutualFund,
    },
    {
        name: 'SIP Calculator',
        path: 'mutual-fund/explore/sip-calculator',
        component: SIPCalculator
    },
    {
        name: 'Goal Calculator',
        path: 'mutual-fund/explore/goal-calculator',
        component: GoalCalculator
    },
    {
        name: 'Selected Category Funds',
        path: 'mutual-fund/explore/selected-category-funds',
        component: SelectedCategorySchemes,
    },
    {
        name: 'eCAS Reports',
        path: 'mutual-fund/ecas-reports',
        component: EcasDownloads,
    },
    {
        name: 'Fund Details',
        path: 'mutual-fund/explore/selected-category-funds/investment-details',
        // component: InvestmentDetails,
        component: Transaction,
        // component: TestInvestment,
    },
    {
        name: 'Individual Fund Dashboard',
        path: 'mutual-fund/explore/:individualFundId',
        component: IndividualFundDetails,
    },
    {
        name: 'Individual Fund Dashboard',
        path: 'mutual-fund/explore/:individualFundId/investment-details',
        component: Transaction,
    },
    {
        name: 'Individual Fund Dashboard',
        path: 'mutual-fund/explore/selected-category-funds/:individualFundId',
        component: IndividualFundDetails,
    },
    {
        name: 'Individual Fund Details',
        path: 'mutual-fund/explore/selected-category-funds/:individualFundId/investment-details',
        component: Transaction,
        // component: InvestmentDetails,

    },
    {
        name: 'Invest More',
        path: 'mutual-fund/invest-more',
        // component: InvestmentDetails,
        component: Transaction,
    },
    {
        name: 'Reedem',
        path: 'mutual-fund/redeem',
        component: Redeem,
    },
    {
        name: 'Switch',
        path: 'mutual-fund/switch',
        component: SwitchAndStp,
    },
    {
        name: 'STP',
        path: 'mutual-fund/stp',
        component: SwitchAndStp,
    },
    {
        name: 'SWP',
        path: 'mutual-fund/swp',
        // component: SWP,
        component: Swp
    },
    {
        name: 'DownloadUploadXSIP',
        path: 'mutual-fund/download-upload-xsip',
        component: DownloadUploadXSIP,
    },
]


function Routes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => <Route
                    exact
                    key={index}
                    path={`${path}/${item.path}`}
                    component={item.component}
                />)
            }
        </Switch>
    );
}

export default function InvestorProfileRouter(): JSX.Element {

    return (
        <CommonLayout>
            <Routes />
        </CommonLayout>
    )
}
